var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasTerms)?_c('div',{staticClass:"e-claim-terms"},[(_vm.hasHeader)?_c('div',{staticClass:"e-claim-terms__header flex flex-col mx-auto"},_vm._l((_vm.terms.header),function(header,index){return _c('h3',{key:index,staticClass:"mb-2 text-base",class:{
				'border border-gray-800 px-2 py-1': header.outline,
				'font-medium': header.bold,
				'font-normal': !header.bold,
				italic: header.italics,
				underline: header.underline,
				'text-center': header.center,
			}},[_vm._v(" "+_vm._s(header.text)+" ")])}),0):_vm._e(),_c('div',{staticClass:"e-claim-terms__body leading-medium text-justify text-xs md:text-sm",class:{ 'mb-4': _vm.hasFooter },staticStyle:{"hyphens":"auto"},domProps:{"innerHTML":_vm._s(_vm.terms.body)}}),(_vm.hasFooter)?_c('div',{staticClass:"e-claim-terms__footer"},_vm._l((_vm.terms.footer),function(footer,index){return _c('h4',{key:index,staticClass:"text-base",class:{
				'border border-gray-800 px-2 py-1': footer.outline,
				'font-medium': footer.bold,
				'font-normal': !footer.bold,
				italic: footer.italics,
				underline: footer.underline,
				'text-center': footer.center,
				'mb-2': index + 1 < _vm.terms.footer.length,
			}},[_vm._v(" "+_vm._s(footer.text)+" ")])}),0):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }